import React, { useState, useEffect } from 'react';

//import '../css/dashboard.css';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handleDownload } from '../Helpers/CommonHelpers';
import { Conversions } from '../Conversion/Conversions';
import Inputs from '../Common/Inputs'; // 👈 Your reusable component
import Output from '../Common/Output';
import { GetRandomBlogPost, GetPageContentBySlug } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import ConversionActions from '../Common/ConversionActions';
import { useLocation } from "react-router-dom";

const Dashboard = () => {
    const [inputJson, setInputJson] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(16);
    const [tabSpace, setTabSpace] = useState(2);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });
    const [randomPost, setRandomPost] = useState('');
    const [showGoTop, setShowGoTop] = useState(false);
    const [loadingPost, setLoadingPost] = useState(true);
    const [pageContent, setpageContent] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const handleBlogClick = () => navigate('/blog/:paramlink');

    const paramlink = location.pathname.split("/").filter(Boolean).pop();

    const handleConversion = () => {
        Conversions(inputJson, setOutputData, setIsError, tabSpace);
    };

    const randomBlogPost = async () => {
        setLoadingPost(true);
        try {
            const randomPost = await GetRandomBlogPost();
            const jsonPostList = JSON.parse(randomPost);
            setRandomPost(jsonPostList);
            setLoadingPost(false);
        } catch (error) {
            setLoadingPost(false);
            console.error('Error fetching the data:', error);
        }
    }

    const GetPageContent = async () => {
        if (paramlink !== undefined && paramlink !== "") {
            try {
                const postMetaList = await GetPageContentBySlug(paramlink);
                const jsonMetaList = JSON.parse(postMetaList);
                setpageContent(jsonMetaList);
            } catch (error) {
                console.error('Error fetching the meta data:', error);
            }
        }
    };

    const handleGoTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        randomBlogPost();
        GetPageContent();
        const handleScroll = () => {
            setShowGoTop(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        // Initialize Owl Carousel after component mounts
        if (window.$ && window.$('.breaking-news-slider').owlCarousel) {
            window.$('.breaking-news-slider').owlCarousel({
                items: 1,
                loop: true,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayHoverPause: true,
                margin: 30,
                autoplaySpeed: 1000,
                animateOut: "slideOutDown",
                animateIn: "slideInDown"
            });
        }

        if (window.$ && window.$('.main-slider').owlCarousel) {
            window.$('.main-slider').owlCarousel({
                loop: true,
                nav: true,
                dots: false,
                mouseDrag: true,
                autoplay: true,
                autoplayHoverPause: true,
                smartSpeed: 1500,
                items: 1,
                navText: [
                    "<i class='bx bx-left-arrow-alt'></i>",
                    "<i class='bx bx-right-arrow-alt'></i>"
                ]
            });
        }

        if (window.$ && window.$('.blog-slider').owlCarousel) {
            window.$('.blog-slider').owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                mouseDrag: true,
                items: 1,
                dots: true,
                autoplay: false,
                smartSpeed: 1500,
                autoplayHoverPause: true,
                center: false,
                navText: [
                    "<i class='bx bx-chevrons-left'></i>",
                    "<i class='bx bx-chevrons-right'></i>"
                ],
                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 3
                    }
                }
            });
        }

    }, []);
    return (
        <div>

            <Header />
            {/* Search Overlay */}
            <div className="search-overlay">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="search-overlay-layer"></div>
                        <div className="search-overlay-layer"></div>
                        <div className="search-overlay-layer"></div>

                        <div className="search-overlay-close">
                            <span className="search-overlay-close-line"></span>
                            <span className="search-overlay-close-line"></span>
                        </div>

                        <div className="search-overlay-form">
                            <form>
                                <input type="text" className="input-search" placeholder="Search here..." />
                                <button type="submit"><i className='bx bx-search'></i></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Search Overlay */}

            {/* Start Breaking News Area */}
            <RandomContent />
            {/* End Breaking News Area */}

            {/* Start Blog Area */}
            <div className="blog-area">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">Online Tools for Data Formatting, Minification, and Conversion.</a></h4>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                pageContent?.section1text && pageContent.section1text.trim() !== ""
                                                    ? pageContent.section1text
                                                    : `Data Beautifier is your one-stop destination for all your data formatting needs. Our website offers an extensive range of tools, including Data Formatting Tools, Online Minification Tools, Base64 Tools, JSON and HTML Beautifier, and Online Code Formatter. Simplify complex tasks like converting JSON to XML, XML to JSON, and minifying or beautifying your code with just a few clicks. Designed with user convenience in mind, Data Beautifier ensures quick, accurate results without hassle. Whether you're a developer or data analyst, our free tools make managing data effortless. Visit Data Beautifier and streamline your workflow today!`,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="thumb">
                                    <Inputs
                                        value={inputJson}
                                        setValue={(val) => {
                                            setInputJson(val);
                                            setIsError(false); // Reset error on change
                                        }}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        isError={isError}
                                        lineCol={inputLnCol}
                                        setLineCol={setInputLnCol}
                                        readOnly={false}
                                        idPrefix="input"
                                    />
                                </div>
                            </div>
                        </div>
                        <ConversionActions
                            tabSpace={tabSpace}
                            setTabSpace={setTabSpace}
                            handleConversion={handleConversion}
                            outputData={outputData}
                            randomPost={randomPost}
                            loadingPost={loadingPost}
                            handleBlogClick={handleBlogClick}
                        />

                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="1200">
                                <div className="thumb">
                                    <Output
                                        value={outputData}
                                        setValue={setOutputData}
                                        lineCol={outputLnCol}
                                        setLineCol={setOutputLnCol}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        idPrefix="output"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 2 Below Boxes */}
            {pageContent?.section2text &&
                pageContent.section2text.trim() !== "" && (
                    <div className="blog-area">
                        <div className="container-block-fluid">
                            <div className="row justify-content-center">
                                <div className="full-col col-lg-12 col-md-12">
                                    <div className="single-blog-inner" data-aos="fade-up"
                                        data-aos-duration="2800">
                                        <div className="details">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: pageContent.section2text,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            {/* Section 3 Below Boxes */}
            {pageContent?.section3text &&
                pageContent.section3text.trim() !== "" && (
                    <div className="blog-area">
                        <div className="container-block-fluid">
                            <div className="row justify-content-center">
                                <div className="full-col col-lg-12 col-md-12">
                                    <div
                                        className="single-blog-inner"
                                        data-aos="fade-up"
                                        data-aos-duration="2800"
                                    >
                                        <div className="details">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: pageContent.section3text,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            <Footer />

            {/* Start Go Top Area */}
            <div className="go-top">
                <i className='bx bx-chevrons-up'></i>
            </div>
            <div className={`go-top${showGoTop ? ' active' : ''}`}
                onClick={handleGoTop}
                style={{ cursor: 'pointer' }}
            >
                <i className='bx bx-chevrons-up'></i>
            </div>
            {/* End Go Top Area */}
            <ToastContainer />
        </div>
    );
};

export default Dashboard;
